import createReducer from "reducers/createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { addFiltering } from "reducers/common/Filtering";
import { addColumnFilters } from "reducers/common/ColumnFilters";

const initialState = {
	items: [],
	isLoading: false,
	isLoadingQrCodeConfiguration: false,
	hasErrorLoading: false,
	generatingQrCode: false,
	errorGeneratingQrCode: false,
	totalPages: 1,
	totalItems: 0,
};
const DEFAULT_QR_CODE_CONFIGURATION = {
	name: "",
	defaultTargetUrl: "",
	extraParams: [{ key: "", value: "" }],
	toggleRedirectConfigurations: false,
	redirect: {
		android: "",
		ios: "",
	},
};

export const GENERATE_QR_CODES_ACTIONS = {
	GENERATE_QR_CODE_AJAX: "GENERATE_QR_CODE_AJAX",
	GENERATE_QR_CODE_SUCCESS: "GENERATE_QR_CODE_SUCCESS",
	GENERATE_QR_CODE_ERROR: "GENERATE_QR_CODE_ERROR",
};
export const GET_QR_CODE_CONFIGURATION_ACTIONS = {
	GET_QR_CODE_CONFIGURATION_ACTIONS_AJAX: "GET_QR_CODE_CONFIGURATION_ACTIONS_AJAX",
	GET_QR_CODE_CONFIGURATION_ACTIONS_SUCCESS: "GET_QR_CODE_CONFIGURATION_ACTIONS_SUCCESS",
	GET_QR_CODE_CONFIGURATION_ACTIONS_ERROR: "GET_QR_CODE_CONFIGURATION_ACTIONS_ERROR",
};
export const GENERATE_QR_CODES_HANDLERS = {
	[GENERATE_QR_CODES_ACTIONS.GENERATE_QR_CODE_AJAX]: onGenerateQrCodeRequest,
	[GENERATE_QR_CODES_ACTIONS.GENERATE_QR_CODE_SUCCESS]: onSuccessGenerateQrCode,
	[GENERATE_QR_CODES_ACTIONS.GENERATE_QR_CODE_ERROR]: onErrorGenerateQrCode,
	isSubmittingQrCodeDesign: false,
};

const GET_QR_CODE_CONFIGURATION_HANDLERS = {
	[GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_AJAX]: onGetQrCodeConfigurationRequest,
	[GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_SUCCESS]: onSuccessGetQrCodeConfigurationRequest,
	[GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_ERROR]: onErrorGetQrCodeConfigurationRequest,
};

export const QR_CODES_ACTIONS = {
	FETCH_QRS_ERROR: "FETCH_QRS_ERROR",
	FETCH_QR_CODES_AJAX: "FETCH_QR_CODES_AJAX",
	FETCH_QR_CODES_SUCCESS: "FETCH_QR_CODES_SUCCESS",
	RESET_QR_CODES_LIST: "RESET_QR_CODES_LIST",
	...GENERATE_QR_CODES_ACTIONS,
	...GET_QR_CODE_CONFIGURATION_ACTIONS,
};

export const handlers = {
	[QR_CODES_ACTIONS.FETCH_QRS_ERROR]: getQrsError,
	[QR_CODES_ACTIONS.FETCH_QR_CODES_AJAX]: getQrCodesRequest,
	[QR_CODES_ACTIONS.FETCH_QR_CODES_SUCCESS]: getQrCodesSuccess,
	[QR_CODES_ACTIONS.RESET_QR_CODES_LIST]: resetQrCodesList,
	...GENERATE_QR_CODES_HANDLERS,
	...GET_QR_CODE_CONFIGURATION_HANDLERS,
};

let reducerConfig = {
	typeRoot: "QR_CODES",
	actionTypes: QR_CODES_ACTIONS,
	actionCreators: {
		getQrCodes,
		clearQrCodes,
		generateQrCode,
		editQrCode,
		getQrCodeConfiguration,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "dateLastUpdate:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {
	dateLastUpdate: {
		name: "dateLastUpdate",
		type: "Date",
		displayName: "Last Modified",
	},
});

function onGenerateQrCodeRequest(state) {
	return {
		...state,
		generatingQrCode: true,
		errorGeneratingQrCode: false,
	};
}
function onSuccessGenerateQrCode(state) {
	return {
		...state,
		generatingQrCode: false,
		errorGeneratingQrCode: false,
	};
}
function onErrorGenerateQrCode(state) {
	return {
		...state,
		generatingQrCode: false,
		errorGeneratingQrCode: true,
	};
}

function onGetQrCodeConfigurationRequest(state) {
	return {
		...state,
		isLoadingQrCodeConfiguration: true,
		hasErrorLoading: false,
	};
}
function onSuccessGetQrCodeConfigurationRequest(state) {
	return {
		...state,
		isLoadingQrCodeConfiguration: false,
		hasErrorLoading: false,
	};
}
function onErrorGetQrCodeConfigurationRequest(state) {
	return {
		...state,
		isLoadingQrCodeConfiguration: false,
		hasErrorLoading: true,
	};
}

export function onSuccessGetQrCodeConfiguration(action) {
	let { data } = action.payload;
	let extraParams = data.extraParams ?? [...DEFAULT_QR_CODE_CONFIGURATION.extraParams];
	const useRedirect = data.redirectConfigurations?.length > 0 || false;
	return {
		name: data.name || DEFAULT_QR_CODE_CONFIGURATION.name,
		defaultTargetUrl: data.defaultTargetUrl || DEFAULT_QR_CODE_CONFIGURATION.defaultTargetUrl,
		extraParams,
		toggleRedirectConfigurations: useRedirect,
		redirect: useRedirect ? { ...data.redirectConfigurations[0].values } : { ...DEFAULT_QR_CODE_CONFIGURATION.redirect },
	};
}
export function onErrorGetQrCodeConfiguration() {
	return { ...DEFAULT_QR_CODE_CONFIGURATION };
}

export function getQrsError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

export function getQrCodesRequest(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

export function getQrCodesSuccess(state, action) {
	let { data } = action.payload;

	return {
		...state,
		...data,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function generateQrCode(idQrDesign, qrCodeConfiguration){
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.GENERATE_QR_CODE_AJAX,
			AJAX: {
				gateway: "qrm",
				url: `qrcodedesigns/${idQrDesign}/qrcodes`,
				method: "post",
				data: { ...qrCodeConfiguration, generatedFrom: "crm" },
				success: QR_CODES_ACTIONS.GENERATE_QR_CODE_SUCCESS,
				error: QR_CODES_ACTIONS.GENERATE_QR_CODE_ERROR,
			},
		});
	};
}
function editQrCode(idQrCode, qrCodeConfiguration){
	return (dispatch) => {
		if (!idQrCode) {
			return dispatch({ type: QR_CODES_ACTIONS.GENERATE_QR_CODE_ERROR, success: false });
		}
		return dispatch({
			type: QR_CODES_ACTIONS.GENERATE_QR_CODE_AJAX,
			AJAX: {
				gateway: "qrm",
				url: `qrcodes/${idQrCode}`,
				method: "put",
				data: qrCodeConfiguration,
				success: QR_CODES_ACTIONS.GENERATE_QR_CODE_SUCCESS,
				error: QR_CODES_ACTIONS.GENERATE_QR_CODE_ERROR,
			},
		});
	};
}
function getQrCodeConfiguration(idQrCode) {
	return (dispatch) => {
		if (!idQrCode) {
			return dispatch({
				type: GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_SUCCESS,
				payload: { data: { body: {} } },
			});
		}
		return dispatch({
			type: GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: "qrm",
				url: `qrcodes/${idQrCode}`,
				success: GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_SUCCESS,
				error: GET_QR_CODE_CONFIGURATION_ACTIONS.GET_QR_CODE_CONFIGURATION_ACTIONS_ERROR,
			},
		});
	};
}

export function getQrCodes(libraryId, idDesign) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.qrCodes;
		return dispatch({
			type: QR_CODES_ACTIONS.FETCH_QR_CODES_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				params: filterInfo,
				url: `ui/creativelibraries/${libraryId}/qrcodedesigns/${idDesign}/qrcodes`,
				success: QR_CODES_ACTIONS.FETCH_QR_CODES_SUCCESS,
				error: QR_CODES_ACTIONS.FETCH_QRS_ERROR,
				gateway: "qrm",
			},
		});
	};
}

export function clearQrCodes() {
	return (dispatch) => {
		dispatch({
			type: QR_CODES_ACTIONS.RESET_QR_CODES_LIST,
		});
		return Promise.resolve({ success: true });
	};
}

function resetQrCodesList(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo,
		columnFilters: state.columnFilters,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const QrCodes = reducerConfig.actionCreators;
